export var WithdrawTagType;
(function (WithdrawTagType) {
    WithdrawTagType["RMB"] = "rmb";
    WithdrawTagType["CRYPTO"] = "crypto";
    WithdrawTagType["WALLET"] = "wallet";
    WithdrawTagType["AGENT_WALLET"] = "agent_wallet";
})(WithdrawTagType || (WithdrawTagType = {}));
//# sourceMappingURL=WithdrawTagType.js.map